import { memo } from 'react';
import { URL, buildRootUrl } from '@/common/app/utils/urlsUtils';
import mainImage from '@/shared/images/Images/home-slide2.webp';
import { VisitorsGuideProps } from '@/common/service/api/Destination/Destination.domain';
import { IDestination, IDestinationList } from '@/entities/Destination/domain/Destination.domain';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';

const VisitorsGuideMeta = ({
    pageDestination,
}: {
    pageDestination: VisitorsGuideProps & IDestination & IDestinationList;
}) => {
    const canonical = buildRootUrl(pageDestination.url);

    const imageSrc =
        pageDestination.id !== '0'
            ? `${URL.image}/destination/${pageDestination.id}/1080x1080/${pageDestination.slug}.jpg`
            : mainImage.src;

    return (
        <CommonMeta
            title={pageDestination.meta.title}
            description={pageDestination.meta.description}
            imageSrc={imageSrc}
            slug={pageDestination.url}
            canonical={canonical}
        />
    );
};

export default memo(VisitorsGuideMeta);
